import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import cs from "./locales/cs.json";
import en from "./locales/en.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            cs: {translation: cs},
            en: {translation: en}
        },
        fallbackLng: "cs",
        supportedLngs: ["cs", "en"],
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "pt-language"
        }
    });

export default i18n;
